import * as yup from 'yup'

export class VehicleConformitySubmissionIssuesDto {
  issueDate?: string = undefined
  issueReason?: string = undefined
  issueNote?: string = undefined
  issueDocumentationFileName?: string = undefined
  issueDocumentationFile?: File = undefined
  needsToBeSentBackToCanada?: string = undefined
}

export const vehicleConformitySubmissionIssuesValidationSchema = yup.object<VehicleConformitySubmissionIssuesDto>({
  issueNote: yup
    .string()
    .nullable()
    .when('issueReason', {
      is: 'Other',
      then: schema => schema.required('Note is required when Issue Reason is "Other".'),
      otherwise: schema => schema.nullable()
    })
})
